<template>
    <div id="listVMRS">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> VMRS List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" v-if="canImportVMRS" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vmrs-code-list">
                        <data-table-filter-config :moduleName="'vmrsList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'vmrsList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listVmrsTable"
                                    mode="remote"
                                    @on-page-change="onPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    :totalRows="totalRecords"
                                    @on-select-all="onSelectAll"
                                    title="VMRS"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :paginate="true"
                                    :paginationOptions="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: false,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }"
                                >

                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>

                                <div slot="selected-row-actions">

                                </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                        <div class="modal fade policy-modal" id="policy-modal" ref="policy-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="policy-modal" aria-hidden="true">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title">Select File</h5>
                                            </div>
                                            <div class="modal-body">
                                                <form id="importFile" class="addinspectionForm">
                                                    <div class="form-row">
                                                        <div class="col form-group">
                                                            <label class="control-label require mb-2" for="name">File:</label><br/>
                                                            <input id="policyFile" type="file" @change="onFileChanged">
                                                            <div class="field-error">{{import_error}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="form-group" v-if="fileName != ''">
                                                        <label class="control-label"> Download Sample file for VMRS </label>
                                                        <a class="pull-right" href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                    </div>
                                                </form>
                                                <!-- <template v-if="duplicatePolicy.customer && duplicatePolicy.customer.length > 0">
                                                    <p>&nbsp;</p>
                                                    <label class="d-block"> Policy Not Imported Because These Customer with Code Not Available:</label>
                                                    <template v-for="(policy,customerKey) in duplicatePolicy.customer">
                                                        <a :key="customerKey" v-if="customerKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="customerKey">{{policy.customer_number}}</span>
                                                    </template>
                                                    <p>&nbsp;</p>
                                                </template> -->
                                                <div class="modal-footer">
                                                    <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                                    <button class="btn btn-primary" id="importButton" v-on:click="importVMRS()"> <i class="fp-import"> </i> Import</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>

    import EventBus from "./event-bus";
    import Vue from 'vue';

    
    



    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';
    import VueSSE from 'vue-sse'
    Vue.use(VueSSE);
    let msgServer;
    export default {
        name: "vmrsList",
        metaInfo: {
            title: "VMRS List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            hideButton:false,
            firstLoad:0,
            userColumns:[],
            columns: [
                // {
                //     label: 'Actions',
                //     field: 'action',
                //     sortable: false,
                // },
                {
                    label: 'VMRS Code',
                    field: 'vmrs_code',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "VMRS", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }

                },
                {
                    label: 'Description',
                    field: 'subsystem_comp_desc',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }

                },
                {
                    label: 'Primary Code',
                    field: 'primary_code',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Sub System Code',
                    field: 'subsystem_code',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "SUB System code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Sub System Component Code',
                    field: 'subsystem_comp_code',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Sub System Component Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            permissions:[],
            cantAccessPage:'',
            action:'list',
            pageKey:"_vmrs_list_",
            selectedFile:"",
            batchId:'',
            batchProcess:false,
            batchNum:'',
            canImportVMRS:false,
            import_error:'',
            file:'',
            fileName:'',
        }),
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_vmrs') {
                        self.cantAccessPage = true;
                    }
                    if(permissions.name == 'add_vmrs') {
                        self.canImportVMRS = true;
                    }
                });
                if (self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            }
        },
        created: function() {
            //this.serverParams.sort = {field:"start_date",type:"desc"};
        },
        mounted: function () {

            var self = this;
            // this.loadList();
            this.getPermissions();


        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listVmrsTable.unselectAllInternal();
            },
            exportReports: function() {
                var self = this;
                this.action = "export";
                this.loadList();
                EventBus.$emit("clearSelection", false);
            },

            loadList: function(){

                var date = new Date();
                var offset = date.getTimezoneOffset();

                var data = this.$refs['listVmrsTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listVmrsTable'].selectedRows[i].id)
                }

                var self = this;
                self.loading =  true;
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/vmrs/list",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    dataType: "json",

                    data:{
                        offset:offset,
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: this.serverParams.columnFilters,
                        sort:self.serverParams.sort,
                        all:self.serverParams.selectedAll,
                        selectedRows:use,
                        action:self.action,
                    },
                    success: function (data) {
                        self.loading =  false;

                        if (data.status == "success") {
                            self.rows = data.content.row;
                            //
                            // self.perPage = data.content.perPage;
                            self.totalRecords = data.content.totalRecords;
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading =  false;
                        self.generateStatusCodeMessage(jqXHR, false, 'citation-list')
                    }
                });
            },

            openModal: function(){
                var self = this;
                self.selectedFile = "";
                self.duplicatePolicy = [];
                $("#policyFile").val('');
                self.import_error = '';
                self.generateExcelSample();
                $('#policy-modal').modal('show');
            },
            generateExcelSample:function(){
                var self = this;

                $.ajax({
                    url:
                    process.env.ROOT_API +
                    "/vmrs-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,

                    success: function(data) {
                        self.loading = false;
                        self.fileName = data.content.file;
                        self.file = data.content.web;

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'telematics-reading-import')

                    }
                });
            },
            onFileChanged(event) {
                const file = event.target.files[0];
                var self = this;
                self.selectedFile = file;
                self.import_error = '';
            },
            importVMRS() {
                var self = this;
                self.import_error = "";
                if(self.selectedFile == "" || self.selectedFile == null){
                    self.import_error = "Please Select Excel File.";
                    return;
                }
                var formData = new FormData();
                formData.append('myFile', self.selectedFile);

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/vmrs-code/import",
                    type: "POST",
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.code == 201){
                            self.$swal('',data.message,'info');
                        }
                        $('#policy-modal').modal('hide');
                        self.loadList();

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'policy-import-error')
                    }
                });
            },
            downloadSample(){
                var self = this;
                // alert(self.file);
                var docPath = self.file;
                var save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/VMRSCodeList.vue